import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-display-key-value',
  template: `
    <div class="aid-layout-row aid-layout-align-start-center aid-layout-gap-8">
      @if (applyPipes) {
        <span class="mat-subtitle-2 basic-color-900">
          {{ key | translate | sentancecase }}:
        </span>
      }
      @if (!applyPipes) {
        <span class="mat-subtitle-2 basic-color-900"> {{ key }}: </span>
      }

      <span class="mat-subtitle-2 basic-color-900">
        @if (!translate) {
          <span>{{ value }}</span>
        }
        @if (translate) {
          <span>{{ value | translate }}</span>
        }
      </span>
    </div>
  `,
  styleUrls: ['./display-key-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DisplayKeyValueComponent implements OnInit {
  @Input() key?: string;
  @Input() value?: string | null;
  @Input() applyPipes = true;
  @Input() translate = false;

  constructor() {}

  ngOnInit() {}
}
